import React from 'react'
import MenuSearchSvg from 'images/modules/Manage/i-menu-search.svg?raw'

export { default as MenuSearchUrl } from 'images/modules/Manage/i-menu-search.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: MenuSearchSvg}} />
)
